export const cookie = {
    search: 'search',
} as const;
